import Box from "@mui/material/Box"
import Popover from "@mui/material/Popover"
import { SxProps } from "@mui/material"
import React from "react"

type Props = {
    children: React.ReactNode
    displayText: string | React.ReactNode
    displayTextStyle?: SxProps
    anchorOrigin?: { vertical: "top" | "center" | "bottom"; horizontal: "left" | "center" | "right" }
    transformOrigin?: { vertical: "top" | "center" | "bottom"; horizontal: "left" | "center" | "right" }
    paperSx?: SxProps
    hoverStyle?: SxProps
}

const MuiPopover = ({
    children,
    displayText,
    displayTextStyle,
    anchorOrigin,
    transformOrigin,
    paperSx,
    hoverStyle,
}: Props) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null)

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl) && Boolean(children)
    const id = open ? "mui-popover" : undefined

    return (
        <Box>
            <Box
                aria-describedby={id}
                onClick={handleClick}
                sx={{
                    cursor: "pointer",
                    ...displayTextStyle,
                    "&:hover": {
                        ...((hoverStyle as object) ?? {}),
                    },
                }}>
                {displayText}
            </Box>

            <Popover
                anchorOrigin={
                    anchorOrigin || {
                        vertical: "center",
                        horizontal: "left",
                    }
                }
                transformOrigin={
                    transformOrigin || {
                        vertical: "top",
                        horizontal: "left",
                    }
                }
                PaperProps={{
                    sx: {
                        ...paperSx,
                    },
                }}
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}>
                {children}
            </Popover>
        </Box>
    )
}

export default MuiPopover
